// extracted by mini-css-extract-plugin
export default {"wrap":"Banner_wrap__-9Nfj","body":"Banner_body__pIFrt","head":"Banner_head__D3Bep","title":"Banner_title__RuWBJ","subtitle":"Banner_subtitle__Wq6gt","text":"Banner_text__7YYpT"};